var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    { attrs: { small: true } },
    [
      _vm.$wait.is("fetching preview resource")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _c(
              "template",
              { slot: "header" },
              [
                _c(
                  "ContentHeader",
                  { attrs: { title: "Notifications", bordered: false } },
                  [
                    _c("template", { slot: "custom-back" }, [
                      _c(
                        "a",
                        {
                          staticStyle: { "margin-bottom": ".5rem" },
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.$router.go(-1)
                            },
                          },
                        },
                        [_vm._v("Go Back")]
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "notifications-container" }, [
              _c("header", { staticClass: "notifications-container__header" }, [
                _c("h3", [_vm._v("Your Notifications")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.resource && _vm.resource.length > 0,
                        expression: "resource && resource.length > 0",
                      },
                    ],
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.handleClearAll.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Clear All")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "notifications-list" },
                _vm._l(_vm.resource, function (notification) {
                  return _c("li", { class: { "is-read": notification.read } }, [
                    _c(
                      "button",
                      {
                        staticClass: "notification-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.handleNotificationClicked(notification)
                          },
                        },
                      },
                      [
                        _c("span", {
                          staticClass: "notification-detail__message",
                          domProps: { innerHTML: _vm._s(notification.message) },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "notification-detail__avatars" },
                          _vm._l(
                            notification.related_users.slice(0, 3),
                            function (user) {
                              return _c("img", {
                                attrs: {
                                  src: user.avatar
                                    ? user.avatar.url
                                    : "//placehold.it/32x32",
                                  alt: `Profile Image for ${user.name}`,
                                },
                              })
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "notification-detail__date",
                          domProps: {
                            textContent: _vm._s(notification.date_formatted),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "clear-notification",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.handleClear(notification.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        ✕\n                    "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }